module.exports = {
	"pathContext": {}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/work-experience.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/work-experience.json
// module chunks = 5356050244152032000